import { baseUrl } from '@/api/types';
import { invoiceIndexUrl } from '@/api/invoice';
import { waybillIndexUrl } from '@/api/waybill';
import { expenseIndexUrl } from '@/api/expense';
import { periodicInvoiceIndexUrl } from '@/api/periodic-invoice';
import { warehousePurchaseIndexUrl } from '@/api/warehouse-purchase';
import { companyContractsIndexUrl } from '@/api/company-contract';
import { moduleIndexUrl } from '@/api/module';
import { toQueryString } from '@/utils/url';

export function activitySourceUrl() {
  return `${baseUrl}/activities-source`;
}

export function countrySourceUrl() {
  return `${baseUrl}/countries-source`;
}

export function vatCodeSourceUrl(countryId = null, $type = '', vatCodes = []) {
  const params = new URLSearchParams();

  if (countryId) {
    params.set('country_id', countryId);
  }

  params.set('type', $type ?? '');

  (vatCodes || [])
    .filter(Boolean)
    .forEach(code => params.append('vat_codes[]', code));

  return `${baseUrl}/vat-codes-source?${params.toString()}`;
}

export function bankSourceUrl() {
  return `${baseUrl}/banks-source`;
}

export function productCategoriesSourceUrl() {
  return `${baseUrl}/product-categories-source`;
}

export function companyActivitySourceUrl() {
  return `${baseUrl}/company-activity-source`;
}

export function invoiceClientSourceUrl(id = null, type = 'invoice') {
  if (id) {
    switch (type) {
      case 'invoice':
        return `${invoiceIndexUrl()}/clients-source?invoice_id=${id}`;
      case 'commercial':
        return `${invoiceIndexUrl()}/clients-source?commercial_id=${id}`;
      case 'work-act':
        return `${invoiceIndexUrl()}/clients-source?work_act_id=${id}`;
    }
  }
  return `${invoiceIndexUrl()}/clients-source`;
}

export function clientSourceUpdateUrl() {
  return `${baseUrl}/invoices/clients-source/update`;
}

export function invoiceSeriesSourceUrl() {
  return `${invoiceIndexUrl()}/series-source`;
}

export function productSourceUrl(params = null) {
  if (params) {
    return `${baseUrl}/products-source?${toQueryString(params)}`;
  }

  return `${baseUrl}/products-source`;
}

export function clientSourceUrl() {
  return `${baseUrl}/clients-source`;
}

export function clientSourceRemoteUrl() {
  return `${baseUrl}/remote-clients-source`;
}

export function waybillReceiverSourceUrl(waybillId) {
  if (waybillId) {
    return `${waybillIndexUrl()}/receiver-source?waybill_id=${waybillId}`;
  }
  return `${waybillIndexUrl()}/receiver-source`;
}

export function waybillSenderSourceUrl(waybillId) {
  if (waybillId) {
    return `${waybillIndexUrl()}/sender-source?waybill_id=${waybillId}`;
  }
  return `${waybillIndexUrl()}/sender-source`;
}

export function waybillCarrierSourceUrl(waybillId) {
  if (waybillId) {
    return `${waybillIndexUrl()}/carriers-source?waybill_id=${waybillId}`;
  }
  return `${waybillIndexUrl()}/carriers-source`;
}

export function waybillSeriesSourceUrl() {
  return `${waybillIndexUrl()}/series-source`;
}

export function expenseClientSourceUrl(expenseId) {
  if (expenseId) {
    return `${expenseIndexUrl()}/clients-source?expense_id=${expenseId}`;
  }
  return `${expenseIndexUrl()}/clients-source`;
}

export function periodicInvoiceClientSourceUrl(periodicInvoiceId) {
  if (periodicInvoiceId) {
    return `${periodicInvoiceIndexUrl()}/clients-source?periodic_invoice_id=${periodicInvoiceId}`;
  }
  return `${periodicInvoiceIndexUrl()}/clients-source`;
}


export function warehouseSourceUrl() {
  return `${baseUrl}/warehouse-source`;
}

export function warehouseProductSourceUrl(params = null) {
  if (params) {
    return `${baseUrl}/warehouse-products-source?${toQueryString(params)}`;
  }

  return `${baseUrl}/warehouse-products-source`;
}

export function warehousePurchaseClientSourceUrl(purchaseId) {
  if (purchaseId) {
    return `${warehousePurchaseIndexUrl()}/clients-source?warehouse_purchase_id=${purchaseId}`;
  }
  return `${warehousePurchaseIndexUrl()}/clients-source`;
}

export function companyVatSourceUrl(type) {
  return `${baseUrl}/company-vat-source/${type}`;
}

export function companyUnitSourceUrl() {
  return `${baseUrl}/company-unit-source`;
}

export function productWarehouseSourceUrl(productId) {
  return `${baseUrl}/product-warehouse-source?product_id=${productId}`;
}

export function companyUserSourceUrl() {
  return `${baseUrl}/company-users-source`;
}

export function companyContractClientSourceUrl(contractId) {
  if (contractId) {
    return `${companyContractsIndexUrl()}/clients-source?contract_id=${contractId}`;
  }
  return `${companyContractsIndexUrl()}/clients-source`;
}

export function finvaldaModuleProductSourceUrl() {
  return `${moduleIndexUrl()}/finvalda-service-source`;
}

export function finvaldaModuleWarehouseSourceUrl() {
  return `${moduleIndexUrl()}/finvalda-warehouse-source`;
}
export function finvaldaCheckUrl(key = null, username = null, password = null, companyId = null) {
  if (key || username || password || companyId) {
    return `${baseUrl}/finvalda-check?key=${encodeURIComponent(key)}&username=${encodeURIComponent(username)}&password=${encodeURIComponent(password)}&finvalda_company_id=${encodeURIComponent(companyId)}`;
  }

  return `${baseUrl}/finvalda-check`;
}

export function registerCountriesSourceUrl(locale = null) {
  if (locale) {
    return `/register-countries?locale=${locale}`;
  }

  return '/register-countries';
}

export function translationUrl(lang = null) {
  const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
  });

  if (lang) {
    return `/translations?lang=${lang}`;
  } else if (params.lang) {
    return `/translations?lang=${params.lang}`;
  }

  return '/translations';
}

export function waybillWarehouseSourceUrl(waybillId, type) {
  if (waybillId) {
    return `${baseUrl}/waybill-warehouse-source?waybill_id=${waybillId}&type=${type}`;
  }

  return `${baseUrl}/waybill-warehouse-source`;
}

export function companyBankSourceUrl() {
  return `${baseUrl}/company-bank-source`;
}
